import { useExternalRowSelectionApi } from 'common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/hooks/useExternalRowSelectionApi';
import { useCallback, useMemo } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useIsRSimInLifeChangesAvailable } from 'rSimInventory/Actions/hooks/useIsRSimInLifeChangesAvailable.ts';

export const useRSimSelectionModel = () => {
  const inlifeChangesEnabled = useIsRSimInLifeChangesAvailable();
  const { selectedIds, setSelectedIds, unSelectAll } = useExternalRowSelectionApi();

  const rowSelectionModel = useMemo(() => {
    if (!inlifeChangesEnabled) {
      return undefined;
    }
    if (selectedIds) {
      return {
        ids: selectedIds,
        type: 'include',
      } as GridRowSelectionModel;
    }
  }, [selectedIds]);

  const onRowSelectionModelChange = useCallback((rowSelectionModel: GridRowSelectionModel) => {
    setSelectedIds(rowSelectionModel.ids);
  }, []);

  return { rowSelectionModel, onRowSelectionModelChange, unSelectAll };
};
